import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../services';

@Injectable({
    providedIn: 'root'
})
export class ResetGuard implements CanActivate {

    constructor(
        private authService: AuthenticationService) {}  

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        return this.authService.checkPasswordResetAviability(next.queryParams);
    }
}
